module.exports = __webpack_public_path__ + "media/yidong-video.9c8ae23a.mp4";